import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Input, InputGroup } from "reactstrap";
import Select from "react-select";
import '../Common/Common.css';

const WHOLE_NUMBER_ERROR = 'Invalid input. Please enter a whole number';

const isWholeNumber = (value) => /^\d+$/.test(String(value));

const clampPredictionNo = (value) => Math.min(100, Math.max(0, Number(value) || 0));

const SelectPredictionValue = props => {

    const { predictionCountryList } = useSelector(state => ({ 
        predictionCountryList: state.GeneralStatistics.countryList,
    }));

    const [npePredictionNoError, setNpePredictionNoError] = useState('');

    const npePredictionCrOptions = predictionCountryList && predictionCountryList.length > 0
        ? predictionCountryList.map(country => ({ value: country.crCode, label: `${country.crCode} ${country.crName}` }))
        : [];

    const selectedNpePredictionCrOption = npePredictionCrOptions.find(
        option => option.value === props.formik.values.npePredictionCr
    ) || null;

    const setPredictionNo = (value, error = '') => {
        setNpePredictionNoError(error);
        props.formik.setFieldValue('npePredictionNo', value, false);
        props.formik.setFieldError('npePredictionNo', error || undefined);
    };

    return(
        <>
        <Row className="mb-3 py-2 align-items-center npe-prediction-row">
            <Col md={props.firstColMd ? props.firstColMd : 3}>
                <label
                    className="col-form-label text-primary"
                >
                    {props.componentName ? 
                        props.componentName === 'NpePrediction' ? 'National phase entry prediction' : 'National phase entry prediction' 
                        : 'National phase entry prediction'}
                    <span className="badge bg-primary rounded-pill ms-2 align-middle">New</span>
                </label>
            </Col>
            <Col md={props.componentName && props.componentName === 'NpePrediction' ? 3 : 3}>
                <Select
                    classNamePrefix="select2-selection"
                    name="npePredictionCr"
                    placeholder="Select country for NPE prediction"
                    options={npePredictionCrOptions}
                    value={selectedNpePredictionCrOption}
                    isClearable
                    isSearchable
                    styles={{
                        placeholder: (base) => ({ ...base, fontSize: '0.8rem' })
                    }}
                    onChange={(selectedOption) => {
                        props.formik.setFieldValue('npePredictionCr', selectedOption ? selectedOption.value : '');
                    }}
                />
            </Col>
            <Col md={props.secondColMd ? props.secondColMd : 3} style={props.componentName && props.componentName === 'NpePrediction' ? {textAlign: "right"} : null}>
                <InputGroup>
                    <Input
                        id="quantityInput"
                        className="npe-prediction-input"
                        name="npePredictionNo"
                        type="number"
                        min={0}
                        max={100}
                        step={1}
                        placeholder="Set minimum prediction value"
                        value={props.formik.values.npePredictionNo ?? ''}
                        onChange={e => {
                            const rawValue = e.target.value;

                            if (rawValue === '') {
                                setPredictionNo('');
                                return;
                            }

                            if (!isWholeNumber(rawValue)) {
                                setPredictionNo(rawValue, WHOLE_NUMBER_ERROR);
                                return;
                            }

                            setPredictionNo(clampPredictionNo(rawValue));
                        }}
                    />
                    <div className="input-group-text npe-prediction-spinner">
                        <span
                            className="npe-prediction-spinner-btn"
                            onClick={() => {
                                const current = clampPredictionNo(Math.trunc(Number(props.formik.values.npePredictionNo) || 0));
                                setPredictionNo(Math.min(100, current + 1));
                            }}
                        >
                            <i className="uil uil-angle-up"></i>
                        </span>
                        <span
                            className="npe-prediction-spinner-btn"
                            onClick={() => {
                                const current = clampPredictionNo(Math.trunc(Number(props.formik.values.npePredictionNo) || 0));
                                setPredictionNo(Math.max(0, current - 1));
                            }}
                        >
                            <i className="uil uil-angle-down"></i>
                        </span>
                    </div>
                    <div className="input-group-text">%</div>
                </InputGroup>
                {(npePredictionNoError || props.formik.errors.npePredictionNo) && (
                    <div className="text-danger text-start">{npePredictionNoError || props.formik.errors.npePredictionNo}</div>
                )}
            </Col>
        </Row>
        </>
    )

}

export default SelectPredictionValue;
